import React from 'react';
import { FormattedMessage } from 'react-intl';

export const WeightLabel = () => <FormattedMessage defaultMessage='Weight' description='fulfillmentPlanner.weight' id='jYZAnX' />;
